import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { LoadingComponent } from '../loading'

@Component({
  selector: 'app-async-block',
  templateUrl: './async-block.component.html',
  styleUrl: './async-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingComponent],
})
export class AsyncBlockComponent {
  readonly inRequest = input(false)
}
